import styled from "styled-components";
import { UserOrdersTable } from "../../../../components/private/user/userFinancialComponents/userFinancialListPersonalComponent/styledUserFinancialListPersonalComponent";

export const TokenListHeader = styled.header`
  background-color: var(--button-color-labs);
  border-radius: 8px;
  font-size: var(--font-size-sm);
  color: var(--blue-color-dark);
`;

export const TokenListTable = styled(UserOrdersTable)`
  color: var(--blue-color-dark);
`;
